// Castintech dashboard — Beni Bekleyen (Faz 48 PR-C) view modulu.
// CHARTER § 7.x görünürlük katmanı. Endpoint: GET /castintech-api/issues/awaiting-yilmaz
// Notify cron her gün 09:15 TRT Telegram digest gönderir; bu sayfa anlık görünüm.
//
// ADR: wiki/decisions/faz48-pr-c-onay-matrisi-v2.md

const ENDPOINT = '/castintech-api/issues/awaiting-yilmaz';
const PAPERCLIP_BASE = '/CAS/issues';

let cache = { count: 0, rows: [], fetchedAt: 0 };

// F4-B (2026-05-26) — Status + agent filter (kullanıcı 130+ satırlık queue'yu daraltabilsin)
let _statusFilter = '';
let _agentFilter = '';

function priorityColor(p) {
  if (p === 'P0') return '#ef4444';
  if (p === 'P1') return '#f59e0b';
  return '#94a3b8';
}

function fmtHours(h) {
  if (h < 24) return h + 'h';
  return Math.floor(h / 24) + 'g ' + (h % 24) + 'h';
}

async function fetchAwaiting() {
  try {
    const r = await fetch(ENDPOINT, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const j = await r.json();
    cache = { count: j.count || 0, rows: j.rows || [], fetchedAt: Date.now() };
    // Update badge
    const badge = document.getElementById('beni-bekleyenler-badge');
    if (badge) {
      if (cache.count > 0) {
        badge.textContent = String(cache.count);
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }
  } catch (e) {
    cache = { count: 0, rows: [], fetchedAt: Date.now(), error: e.message };
  }
}

export async function renderBeniBekleyenler() {
  // Cache 60s (background refresh)
  if (Date.now() - cache.fetchedAt > 60000) await fetchAwaiting();

  const sub = document.getElementById('bb-sub');
  if (sub) {
    if (cache.error) sub.textContent = 'Hata: ' + cache.error;
    else sub.textContent = cache.count + ' bekleyen iş · son kontrol az önce';
  }

  const list = document.getElementById('bb-list');
  if (!list) return;

  if (!cache.rows.length) {
    list.innerHTML = '<div style="padding:24px;text-align:center;color:#94a3b8"><div style="font-size:32px">✅</div><div style="margin-top:8px">Beni bekleyen iş yok — temiz.</div></div>';
    return;
  }

  // F4-B — Filter dropdown bar (status + agent)
  const allStatuses = Array.from(new Set(cache.rows.map(r => r.status))).sort();
  const allAgents = Array.from(new Set(cache.rows.map(r => r.agent).filter(Boolean))).sort();
  const filterBar = '<div style="display:flex;gap:12px;align-items:center;padding:8px 12px;border-bottom:1px solid #1e293b;background:#0f172a;font-size:12px">'
    + '<label for="bb-status-filter" style="color:#94a3b8">Durum:</label>'
    + '<select id="bb-status-filter" style="padding:3px 8px;background:#1e293b;color:#e2e8f0;border:1px solid #334155;border-radius:4px">'
    + '<option value="">Tümü</option>'
    + allStatuses.map(s => '<option value="' + s + '"' + (_statusFilter === s ? ' selected' : '') + '>' + s + '</option>').join('')
    + '</select>'
    + '<label for="bb-agent-filter" style="color:#94a3b8;margin-left:8px">Ajan:</label>'
    + '<select id="bb-agent-filter" style="padding:3px 8px;background:#1e293b;color:#e2e8f0;border:1px solid #334155;border-radius:4px;max-width:180px">'
    + '<option value="">Tümü</option>'
    + allAgents.map(a => '<option value="' + a + '"' + (_agentFilter === a ? ' selected' : '') + '>' + a + '</option>').join('')
    + '</select>'
    + '<button id="bb-filter-clear" style="margin-left:auto;padding:3px 10px;background:#1e293b;color:#94a3b8;border:1px solid #334155;border-radius:4px;cursor:pointer">Temizle</button>'
    + '</div>';

  // Apply filters
  const filteredRows = cache.rows.filter(r => {
    if (_statusFilter && r.status !== _statusFilter) return false;
    if (_agentFilter && r.agent !== _agentFilter) return false;
    return true;
  });

  if (!filteredRows.length) {
    list.innerHTML = filterBar + '<div style="padding:24px;text-align:center;color:#94a3b8">Filtre eşleşmesi yok.</div>';
    bindBeniBekleyenlerFilters(list);
    return;
  }

  // Group by priority (filtered)
  const groups = { P0: [], P1: [], P2: [] };
  for (const r of filteredRows) (groups[r.priority_hint] || groups.P2).push(r);

  const html = [];
  for (const lvl of ['P0', 'P1', 'P2']) {
    if (!groups[lvl].length) continue;
    const label = lvl === 'P0' ? 'P0-KRİTİK' : lvl === 'P1' ? 'P1-YÜKSEK' : 'P2';
    html.push('<div style="margin:16px 12px 8px;font-size:11px;letter-spacing:0.5px;color:' + priorityColor(lvl) + ';font-weight:600">' + label + ' (' + groups[lvl].length + ')</div>');
    html.push('<table style="width:100%;border-collapse:collapse;font-size:13px"><thead style="background:#1e293b;color:#94a3b8"><tr><th style="text-align:left;padding:8px 12px">ID</th><th style="text-align:left;padding:8px 12px">Ajan</th><th style="text-align:left;padding:8px 12px">Durum</th><th style="text-align:left;padding:8px 12px">Başlık</th><th style="text-align:right;padding:8px 12px">Bekleme</th><th style="text-align:center;padding:8px 12px">Aksiyon</th></tr></thead><tbody>');
    for (const it of groups[lvl]) {
      const safeTitle = (it.title || '').replace(/[<>&"]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]));
      html.push('<tr style="border-bottom:1px solid #1e293b"><td style="padding:8px 12px"><a href="' + PAPERCLIP_BASE + '/' + it.identifier + '" target="_blank" style="color:#60a5fa;text-decoration:none">' + it.identifier + '</a></td>'
        + '<td style="padding:8px 12px;color:#cbd5e1">' + (it.agent || '<i>atanmamış</i>') + '</td>'
        + '<td style="padding:8px 12px"><span style="padding:2px 8px;border-radius:4px;background:' + (it.status === 'blocked' ? '#7c2d12' : it.status === 'in_review' ? '#1e40af' : '#1f2937') + ';font-size:11px">' + it.status + '</span></td>'
        + '<td style="padding:8px 12px;color:#e2e8f0">' + safeTitle + '</td>'
        + '<td style="padding:8px 12px;text-align:right;color:#f87171;font-weight:600">' + fmtHours(it.hours_waiting) + '</td>'
        + '<td style="padding:8px 12px;text-align:center;white-space:nowrap">'
        + '<button class="bb-act" data-act="retrigger" data-id="' + it.identifier + '" title="Yeniden tetikle (todo + agent ata)" style="padding:3px 8px;margin:0 2px;background:#14532d;color:#86efac;border:1px solid #166534;border-radius:4px;cursor:pointer">▶</button>'
        + '<button class="bb-act" data-act="note" data-id="' + it.identifier + '" title="Not ekle" style="padding:3px 8px;margin:0 2px;background:#1e3a5f;color:#93c5fd;border:1px solid #1e40af;border-radius:4px;cursor:pointer">✎</button>'
        + '<button class="bb-act" data-act="cancel" data-id="' + it.identifier + '" title="İptal et" style="padding:3px 8px;margin:0 2px;background:#450a0a;color:#fca5a5;border:1px solid #7f1d1d;border-radius:4px;cursor:pointer">✖</button>'
        + '</td></tr>');
    }
    html.push('</tbody></table>');
  }
  list.innerHTML = filterBar + html.join('');
  bindBeniBekleyenlerFilters(list);
}

// F4-B — Filter dropdown handlers (her render'da yeniden bind — innerHTML replaces)
function bindBeniBekleyenlerFilters(list) {
  const statusSel = list.querySelector('#bb-status-filter');
  const agentSel = list.querySelector('#bb-agent-filter');
  const clearBtn = list.querySelector('#bb-filter-clear');
  if (statusSel) statusSel.addEventListener('change', () => { _statusFilter = statusSel.value; renderBeniBekleyenler(); });
  if (agentSel) agentSel.addEventListener('change', () => { _agentFilter = agentSel.value; renderBeniBekleyenler(); });
  if (clearBtn) clearBtn.addEventListener('click', () => { _statusFilter = ''; _agentFilter = ''; renderBeniBekleyenler(); });

  // Müdahale aksiyonları (2026-06-10): retrigger / not / iptal — delegated, inline handler yok.
  list.querySelectorAll('.bb-act').forEach(btn => btn.addEventListener('click', async () => {
    const act = btn.dataset.act, id = btn.dataset.id;
    let note = '';
    if (act === 'cancel') { if (!confirm(id + ' IPTAL edilsin mi?')) return; note = prompt('Gerekce (opsiyonel):') || ''; }
    if (act === 'note') { note = prompt(id + ' icin not:') || ''; if (!note) return; }
    if (act === 'retrigger' && !confirm(id + ' yeniden tetiklensin mi? (todo + agent atanir, dispatch baslar)')) return;
    btn.disabled = true; const orig = btn.textContent; btn.textContent = '…';
    try {
      const r = await fetch('/castintech-api/issues/by-identifier/' + encodeURIComponent(id) + '/action', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: act, note })
      });
      const j = await r.json().catch(() => ({}));
      btn.textContent = r.ok ? '✓' : '✗';
      if (!r.ok) alert('Hata: ' + (j.error || r.status));
      else setTimeout(() => { cache.fetchedAt = 0; renderBeniBekleyenler(); }, 900);
    } catch (e) { btn.textContent = '✗'; alert('Hata: ' + e.message); }
    finally { setTimeout(() => { btn.disabled = false; btn.textContent = orig; }, 1500); }
  }));
}

// Pre-fetch on module load so badge updates without view activation
fetchAwaiting();

// Bind refresh button (no inline handlers — Faz 10 dashboard guard).
function bindRefreshButton() {
  const btn = document.getElementById('bb-refresh-btn');
  if (!btn || btn.__bound) return;
  btn.__bound = true;
  btn.addEventListener('click', async () => {
    cache.fetchedAt = 0;
    await renderBeniBekleyenler();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindRefreshButton);
} else {
  bindRefreshButton();
}
